export default function () {
    function buildReactiveHead(stream, error) {
        watch(
            stream,
            () => {
                buildHead(stream.value, error.value);
            },
            {immediate: true},
        );
    }

    function buildHead(stream, error) {
        if (stream === null && !error) return useSeo().buildHeadLoading();
        if (!stream) return useSeo().buildHeadNotFound();
        return useSeo().buildHead({
            image: stream.stream_image_url,
            title: stream.stream_title,
            description: stream.stream_excerpt,
            index: false,
        });
    }

    return {buildReactiveHead};
}
